import { Box, Typography, IconButton, Tooltip } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

export default function AdminPageHeader({ title }) {
  const navigate = useNavigate();

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mb: 1, my: 1 }}>
      <Tooltip title="Voltar">
        <IconButton size="small" onClick={() => navigate(-1)}>
          <ArrowBackIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Typography variant="h7" sx={{ fontWeight: 700, ml: 0.5, color: "text.primary" }}>
        {title}
      </Typography>
    </Box>
  );
}
